import React from 'react'
import { ThemeProvider } from '@mui/material';


const FullContainer = ({ name, body, theme = {} }) => {
  return (
    <ThemeProvider theme={theme}>
      <div
        style={{
          position: 'absolute',
          width: '90%',
          height: '90%',
          top: '5%',
          left: '5%',
          padding: '20px',
          borderRadius: '10px',
          background: '#333333',
          zIndex: 2000,
          overflowY: 'auto',
          fontFamily: 'proximanova !important',
          overflowX: 'hidden',
        }}
      >
        {body}
      </div>
    </ThemeProvider>
  )
}

export default FullContainer
